import styled, { css } from 'styled-components';
import { getColor, StyleVars } from 'core/utils/Styles';
import { placeholder, resetBtn } from 'styled-manila';
import { default as Srch } from 'core/icons/SearchIcon';

export const DropdownWrapper = styled.div`
	position: absolute;
	top: calc(100% - 2px);
	left: 0;
	right: 0;
	z-index: 1001;
	width: 100%;
	padding: 16px;
	background: ${getColor("white")};
	border-top: 1px solid ${getColor("gray1")};
	border-radius: 0 0 ${StyleVars.defaultBorderRadius} ${StyleVars.defaultBorderRadius};
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HitLink = styled.a`
	display: flex;
	flex-direction: row;
	align-items: center;
	text-decoration: none;
	white-space: normal;
	color: ${getColor("gray")};

	${props => props.$highlight && css`
		font-weight: bold;
		color: ${getColor("darkTeal")};
	`}

	${props => props.$underline && css`
		text-decoration: underline;
		&:focus,
		&:hover {
			text-decoration: underline;
		}
	`}

	&:focus,
	&:hover {
		color: ${getColor("gray")};
		text-decoration: none;
		outline: 0;
	}
`;

export const HitWrapper = styled.div`
	margin-left: -16px;
	margin-right: -16px;
`;

export const HitSuggestion = styled.div`
	font-size: 14px;
	font-weight: normal;
	text-align: left;
	padding: 8px 16px;
	border: none;
	transition: background 0.3s ease-in-out;
	position: relative;

	&.focus,
	&:hover {
		background: ${getColor("porcelain")};
		cursor: pointer;
	}
`;

export const RemoveBtn = styled.button`
	${resetBtn};
	position: absolute;
	right: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 44px;
`;

export const LineRule = styled.hr`
	margin-top: 14px;
	margin-bottom: 14px;
	border-top: 2px solid ${getColor("porcelain")};
`;

export const LinkDesc = styled.div`
	font-style: italic;
	font-size: 13px;
	color: ${getColor("gray8")};
	letter-spacing: 0;

	p {
		margin: 0;
	}
`;

export const LinkWrapper = styled.div`
	width: calc(100% - 50px);
`;

export const Title = styled.div`
	font-weight: 600;
	text-align: left;
	font-size: 12px;
	text-transform: uppercase;
	color: ${getColor("gray8")};
	letter-spacing: 3px;
	margin-bottom: 6px;

	&:not(:first-of-type) {
		margin-top: 6px;
	}
`;

/* <SearchHit /> */
export const CategoryLink = styled(HitLink)`
	font-weight: 600;
`;

export const LinkBgImage = styled.div`
	width: 40px;
	height: 40px;
	background-size: cover;
	margin-right: 8px;
`;

export const LinkBgImageRound = styled(LinkBgImage)`
	border-radius: 50%;
`;

export const StoreName = styled.em`
	font-size: 0.8em;
	font-style: normal;
`;

export const Form = styled.form`
	display: flex;
	width: 100%;
	${placeholder`color: ${getColor('gray8')};`}
	height: auto;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		${placeholder`color: ${getColor('dustyGray')};`}
		background-color: ${getColor('concreteGray')};
		border-radius: 6px;
		width: 95%;
		margin: 0 auto;
	}
`;

export const Input = styled.input`
	background: ${getColor('porcelain')};
	border: 1px solid ${getColor('alto')};
	box-shadow: none;
	display: block;
	width: 100%;
	padding: 1px 12px 0px 12px;
	font-size: 16px;
	height: 48px;
	line-height: 48px;
	appearance: none;
	border-radius: 4px 0px 0px 4px;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		border: none;
		color: ${getColor('dustyGray')};
		background: none;
		height: 40px;
		line-height: 40px;
		border-radius: 0px;
		&:focus {
			height: 72px;
			line-height: 72px;
			/* stylelint-disable property-no-vendor-prefix, value-no-vendor-prefix */
			-webkit-appearance: none;
			border-radius: 0;
			box-shadow: 0;
			caret-color: ${getColor('pelorous')};
			color: ${getColor('black')};
			background-color: ${getColor('white')};
			+ button {
				background-color: ${getColor('white')};
				padding: 0px 0px 0px 15px;
				transition: none
			}
			::placeholder {
				color: transparent;
			}
		}
	}

	@media (max-width: ${StyleVars.screenXsm}) {
		height: 36px;
		line-height: 36px;
	}

	@media (max-width: ${StyleVars.screenMin}) {
		height: 32px;
		line-height: 32px;
	}

	::placeholder {
		color: ${getColor('gray8')};

		@media (max-width: ${StyleVars.desktopScreenSm}) {
			color: ${getColor('dustyGray')};
		}
	}

	&:focus {
		box-shadow: none;
		outline: none;
		border-color: ${getColor('morningGlory')};
	}
`;

export const Submit = styled.button`
	border-radius: 0 4px 4px 0;
	border: none;
	font-size: 16px;
	line-height: 23px;
	letter-spacing: 0.42px;
	padding: 6px 18px;
	background: ${getColor('primaryBrand')};
	color: ${getColor('white')};
	height: auto;
	transition: none;

	&:focus {
		outline: none;
	}

	&:hover {
		background: ${getColor('primaryBrandHover')};
	}

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		order: -1;
		border-radius: 0;
		background: none;
		color: ${getColor('dustyGray')};
		padding: 0px 0px 0px 18px;
	}
`;

export const SearchIcon = styled(Srch)`
	margin-top: 6px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
`;
